import React, { useEffect, useState } from "react";
import UtilList from "./UtilList";
import UtilManagement from "./UtilManagement";

function UtilSelection() {
  const [selectItem, setSelectItem] = useState("");
  useEffect(()=>{
window.scrollTo(0,100)
  },[])
  return (
    <div>
      <div className="selection">
        <div
          onClick={() => {
            selectItem === "add" ? setSelectItem("") : setSelectItem("add");
            selectItem !== ""
              ? selectItem === "add" &&
                document.querySelector(".selection").classList.remove("slide")
              : document.querySelector(".selection").classList.add("slide");
          }}
        >
          <span>Ajouter un utilisateur</span>
          <img src="/sources/add-user.png" alt="add" />
        </div>
        <div
          onClick={() => {
            selectItem === "manage"
              ? setSelectItem("")
              : setSelectItem("manage");
            selectItem !== ""
              ? selectItem === "manage" &&
                document.querySelector(".selection").classList.remove("slide")
              : document.querySelector(".selection").classList.add("slide");
          }}
        >
          <span>Liste des utilisateurs</span>
          <img src="/sources/manage-user.png" alt="manage" />
        </div>
      </div>
      <div>
        {selectItem === "add" && <UtilManagement />}
        {selectItem === "manage" && <UtilList />}
      </div>
    </div>
  );
}

export default UtilSelection;
